@if (inMatrix) {
  <div class="m-2">
    <label class="text-lg" [for]="question.id">
      @if (question.mandatory) {
        <span aria-hidden="true">* </span>
        <p class="sr-only">{{ "question.requiredlabel" | translate }}</p>
      }
      <span [innerHTML]="question.title | safeHtml"></span>
    </label>
  </div>
  <div class="mx-2 mb-4">
    <app-open-answer-input
      [control]="control"
      [question]="question"
    ></app-open-answer-input>
  </div>
} @else {
  <app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
    <app-open-answer-input
      [control]="control"
      [question]="question"
    ></app-open-answer-input>
  </app-question-base>
}
